import { render, staticRenderFns } from "./ListarRegistros.vue?vue&type=template&id=095e33c4&scoped=true&"
import script from "./ListarRegistros.vue?vue&type=script&lang=js&"
export * from "./ListarRegistros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e33c4",
  null
  
)

export default component.exports